export default __webpack_public_path__ + "static/media/IMG_2300.e9a43a44.JPG";